import { render, staticRenderFns } from "./SopTile.vue?vue&type=template&id=d955fe32&scoped=true&"
import script from "./SopTile.vue?vue&type=script&lang=ts&"
export * from "./SopTile.vue?vue&type=script&lang=ts&"
import style0 from "./SopTile.vue?vue&type=style&index=0&id=d955fe32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d955fe32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
